<mapfre-alert></mapfre-alert>
<div *ngIf="!showTermsConditions">
  <div class="manage-autopay-header">
    <ng-container 
      *ngIf="whereInTheProcess==='enroll' || (policy?.company.companyName === 'TW' || policy?.company.companyName === 'ACIC');else editEnrollAcmic">
      <div class="manage-autopay-header-title">      
        {{ 'AUTOPAY_ENROLL_TITLE' | translate }}
      </div> 
      <div class="manage-autopay-header-sub-title" *ngIf="policy?.company.companyName !== 'TW'">
        {{ 'EPAY_ENROLL_PARA_NEW' | translate }}
      </div>
      <div class="manage-autopay-header-sub-title" *ngIf="policy?.company.companyName === 'TW' && !isCreditDebitCardMethod">
        {{ 'CHECKING_SAVING_AUTOPAY_TW' | translate }}
      </div>
    </ng-container>
    <ng-template #editEnrollAcmic>
      <div class="manage-autopay-header-title mb-0">      
        {{ 'AUTOPAY_EDIT_TITLE' | translate }}
      </div> 
    </ng-template>
  </div>

  <div class="d-flex">
    <div class="auto-pay-icon">
      <img 
        src="{{policy?.displayType?.icon}}"
        width="32" height="32" 
        alt="{{policy?.policyType?.toLowerCase()}} icon" 
      />         
    </div>

    <div class="autopay-policy-info policy-type-id policy-status">
      <a class="nowrap" [routerLink]="['/my-insurance', policy?.policynumber.policyNumber , 'details']">
        <span class="hide-policy-id-mobile">
          {{ policy?.displayType?.label }} &ndash;
        </span>
        {{ policy?.policynumber.policyNumber }}
      </a>
      <div 
        class="autopay-term" 
        [ngClass]="{ 'dash-red-color': !(policy?.policyStatus === 'ACTIVE' || policy?.policyStatus === 'FUTURE') }"
      >
          {{ policy?.policyStatus === 'ACTIVE' || policy?.policyStatus === 'FUTURE' 
          ? ""
          : policy?.policyStatus | translate | titlecase }} 
          
          {{ policy?.effDate | customDateFormat }} -
          {{ policy?.expDate | customDateFormat }}
      </div>
    </div>
  </div>
</div>
  <app-enroll-eft-epay-form 
    *ngIf="!isCreditDebitCardMethod"
    [inputs]="inputs" 
    (showTermsConditionsEvent)="onShowTermsConditionsEvent($event)">
  </app-enroll-eft-epay-form>
  <app-autopay-card-enrollement-form 
    *ngIf="isCreditDebitCardMethod"
    (showTermsConditionsEvent)="onShowTermsConditionsEvent($event)">
  </app-autopay-card-enrollement-form>

<div *ngIf="!showTermsConditions">
  <div class="row text-center checkingrowbtm ">
    <div class="col">
      <ng-container *ngIf="isAcmic; else maStateBackbtn">
          <mapfre-button
            (click)="navigateBack()"
            additionalClasses="link-button blue-color-link top-information no-padding font-weight-normal"
            [backIcon]="'assets/img/icons/back-arrow-blue.svg'"
            [iconClasses]="'align-middle'"
            [showIconsCustom]="true"
          > 
            {{ 'Back' | translate }}
          </mapfre-button>
      </ng-container>
      <ng-template #maStateBackbtn>
        <mapfre-button
          (click)="navigateBack()"
          additionalClasses="link-button red-link top-information no-padding button-border-red font-weight-500 mt-4"
          [backIcon]="'assets/img/icons/back-arrow-red.svg'" 
          [iconClasses]="'align-middle pr-1'"
          [showIconsCustom]="true"
        > 
          <span>{{ 'BACK' | translate }}</span>
        </mapfre-button>
      </ng-template>
    </div>
  </div>
</div>
